import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '@huge-monorepo/shared/modules';
@Component({
  selector: 'huge-monorepo-teltonika-update-name-modal',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './teltonika-update-name-modal.component.html',
  styleUrl: './teltonika-update-name-modal.component.scss',
})
export class TeltonikaUpdateNameModalComponent {
  name: string = '';
  constructor(
    public dialogRef: MatDialogRef<TeltonikaUpdateNameModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ITeltonikaUpdateNameDialogData
  ) { 
      this.name = data.currentName || '';
  }

  closeDialog(save: boolean): void {
    if (!save) {
      this.dialogRef.close({ Name: null });
      return;
    }

    this.dialogRef.close({
      Name: this.name,
    });
  }

  clearSearch() {
    this.name = '';
  }
}

interface ITeltonikaUpdateNameDialogData {
  currentName: string | null
};